import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { mensajeDeError } from '../../api/client';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { Campo, Etiqueta, Entrada, MensajeError } from '../../components/ui/Form';
import { Envoltura, TituloForm, TextoForm } from '../Login';

function AdminLogin() {
  const { loginAdmin } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setError('');
    setEnviando(true);
    try {
      await loginAdmin(email, password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(mensajeDeError(err));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Envoltura>
      <Card>
        <TituloForm>Panel del estudio</TituloForm>
        <TextoForm>Acceso exclusivo para administración y recepción.</TextoForm>
        {error && <MensajeError role="alert">{error}</MensajeError>}
        <form onSubmit={enviar}>
          <Campo>
            <Etiqueta htmlFor="email">Email</Etiqueta>
            <Entrada id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </Campo>
          <Campo>
            <Etiqueta htmlFor="password">Contraseña</Etiqueta>
            <Entrada
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Campo>
          <Button type="submit" $completo disabled={enviando}>
            {enviando ? 'Entrando…' : 'Entrar al panel'}
          </Button>
        </form>
      </Card>
    </Envoltura>
  );
}

export default AdminLogin;
